// 工具函数引入
import { uniqBy, cloneDeep } from 'lodash'

// 引入采购人的动态路由
import purchaseRoutes from '@/router/jxic-router/purchase'
import visualizationRoutes from '@/router/jxic-router/visualization'
import monitorRoutes from '@/router/jxic-router/monitor'
import supplierManageRoutes from '@/router/jxic-router/supplier-manage'
import expertRoutes from '@/router/main/expert'
import financialRoutes from '@/router/main/financial'
import systemRoutes from '@/router/main/enterprise'
// 引入供应商的动态路由  引入代理机构的动态路由
import agencyRoutes from '@/router/business/agency/index'
import supplierRoutes from '@/router/business/supplier/index'
import performanceRoutes from '@/router/performance/index'
import guaranteeRoutes from '@/router/main/guarantee'
import servicesRoutes from '@/router/main/services'
import signatureRoutes from '@/router/main/signature'
import { workbenchServiceDict } from '@/dictionary/system'

/**
 * 将一级的采购履约去除采购人身份
 */
function deletePerformanceRoutesPurchaseIdentity() {
  const loop = list => {
    return list
      .map(route => {
        if (route.children && route.children.length) {
          route.children = loop(route.children)
        }

        if (
          route.applicableCompanyIdentities.includes(
            workbenchServiceDict.PURCHASER.value
          )
        ) {
          return undefined
        }

        return route
      })
      .filter(v => v)
  }

  const performanceRoutesTemp = cloneDeep(performanceRoutes)[0]
  performanceRoutesTemp.applicableCompanyIdentities = [
    workbenchServiceDict.AGENCY.value,
    workbenchServiceDict.SUPPLIER.value
  ]
  performanceRoutesTemp.children = loop(performanceRoutesTemp.children)

  return performanceRoutesTemp
}

/**
 * 将主路由与各子路由配置进行合并
 * @param list
 * @returns {unknown[]|*[]}
 */
const loop = list => {
  if (!list?.length) return []

  const listTemp = uniqBy(list, 'path')
  return listTemp.map(firstRoute => {
    const pathCommonList = list.filter(route => route.path === firstRoute.path)
    list = list.filter(route => route.path !== firstRoute.path)

    if (pathCommonList.length > 1) {
      const commonChildrenList = []
      const commonObj = Object.assign({}, pathCommonList[0], {
        children: []
      })

      for (let i = 0; i < pathCommonList.length; i++) {
        commonChildrenList.push(...(pathCommonList[i].children || []))
      }
      commonObj.children = loop(commonChildrenList)

      return commonObj
    } else {
      return firstRoute
    }
  })
}

export default loop([
  purchaseRoutes,
  agencyRoutes, // 招标采购（代理）
  supplierRoutes, // 投标报价
  deletePerformanceRoutesPurchaseIdentity(),
  visualizationRoutes,
  monitorRoutes,
  supplierManageRoutes,
  expertRoutes,
  financialRoutes, // 财务管理
  guaranteeRoutes, // 灵活宝
  servicesRoutes, // CA中心&会员
  signatureRoutes, // 在线签章
  systemRoutes
])
